import { Input, KeyCode } from "../../../lib/Input";
import Ability from "../../Ability";
import Player from "../../Player";

export default class OverchargedShot extends Ability {

    constructor(player: Player) {
        super(player, {
            cooldown: 12,
            duration: 0,
            energyCost: 30,
            icon: 8,
            trigger: KeyCode.Digit3,
            triggerType: Input.GetKeyDown,
            info: `Overcharged Shot (12s cooldown) - Your next Railgun shot fires a supercharged round dealing 500 damage`
        })
    }

    onUse(): void {
        this.player.chargedShot = true;
    }
}